const Category = () =>
  import(
    /* webpackChunkName: "base-info-poi-category" */ '@/pages/base-info/poi/category/index.vue'
  )
const CreateCategory = () =>
  import(
    /* webpackChunkName: "base-info-cpoi-category" */ '@/pages/base-info/poi/category/create.vue'
  )
const EditCategory = () =>
  import(
    /* webpackChunkName: "base-info-poi-category" */ '@/pages/base-info/poi/category/edit.vue'
  )

export default {
  path: 'category',
  meta: {
    label: 'poiCategory',
    auth: 'category'
  },
  component: {
    name: 'Category',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoPoiCategory',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Category
    },
    {
      name: 'BaseInfoCreatePoiCategory',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCategory
    },
    {
      name: 'BaseInfoEditPoiCategory',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCategory,
      props: true
    }
  ]
}
